import { fail } from '../schema-prompts/fail.js'
import { validateSchemaName } from './validate-schema-name.js'

export function validateProvidedSchemaName(schemaName: string): void {
  const error = validateSchemaName(schemaName)
  if (error) {
    fail(`Invalid schema name "${schemaName}". ${error}`)
  }
}
